import React, { useState } from 'react'
import { css } from '@emotion/css'
import {
  IconStop,
  theme
} from '@contrast-security-inc/design-system-foundations'
import { ModalFooter } from '@contrast-security-inc/design-system-popovers'
import { Box, Row } from '../../../legacy-design-system/form'
import { Text } from '@contrast-security-inc/design-system-typography'
import { Button } from '@contrast-security-inc/design-system-buttons'
import { useIntl } from 'react-intl'
import { DiagnosticCollectionSettings } from '../../servers-grid/shared'
import { DiagnosticCollectionFormValue } from '../index'
import { DiagnosticCollectionStopModal } from './diagnostic-collection-stop-modal'

export function DiagnosticCollectionDisableForm({
  diagnosticCollectionSettings,
  formValue,
  onClick
}: {
  diagnosticCollectionSettings: DiagnosticCollectionSettings
  formValue: DiagnosticCollectionFormValue
  onClick: (value: DiagnosticCollectionFormValue) => void
}) {
  const { formatMessage } = useIntl()
  const [visible, setVisible] = useState(false)
  const startTime = new Date(diagnosticCollectionSettings.startTime * 1)
  const expires = new Date(diagnosticCollectionSettings.expires * 1)

  const timeZone = startTime
    .toLocaleTimeString(undefined, { timeZoneName: 'short' })
    .split(' ')[2]
  return (
    <>
      <Box
        className={css`
          border-style: solid;
          border-width: 1px;
          border-color: ${theme.color.neutral30};
          border-radius: 5px;
        `}
      >
        <Row>
          <Box
            basis={4}
            className={css`
              padding-left: 40px;
            `}
          >
            <Text font="bodyStrong">Log Level</Text>
          </Box>
          <Box basis={4}>
            <Text font="bodyStrong">Collection Start</Text>
          </Box>
          <Box basis={4}>
            <Text font="bodyStrong">Collection End</Text>
          </Box>
        </Row>
        <Box
          className={css`
            border-style: solid;
            border-width: 1px;
            border-color: ${theme.color.neutral30};
            border-bottom: 0px;
            border-right: 0px;
            border-left: 0px;
            padding-left: 10px;
          `}
        >
          <Row>
            <Box
              basis={4}
              className={css`
                padding-left: 10px;
                margin-left: 0px;
              `}
            >
              <Text
                font="body"
                className={css`
                  margin-left: 20px;
                `}
              >
                {diagnosticCollectionSettings.logLevel}
              </Text>
            </Box>
            <Box
              basis={4}
              className={css`
                padding-left: 0px;
              `}
            >
              <Text font="body">
                {startTime.toLocaleDateString()}{' '}
                {startTime.toLocaleTimeString()} {timeZone}
              </Text>
            </Box>
            <Box basis={4}>
              <Text
                font="body"
                className={css`
                  margin-left: 10px;
                `}
              >
                {expires.toLocaleDateString()} {expires.toLocaleTimeString()}{' '}
                {timeZone}
              </Text>
            </Box>
          </Row>
        </Box>
        <ModalFooter>
          <div
            className={css`
              padding: 10px 0;
            `}
          >
            {formatMessage({ id: 'detail_servers_stopDiagnostics' })}
          </div>
          <Button
            variant="destructive"
            className={css`
              font-size: 14px;
            `}
            onClick={() => {
              setVisible(true)
            }}
          >
            <div>
              {<IconStop size="sm" color="black" />}
              {formatMessage({ id: 'action_diagnostic_disable' })}
            </div>
          </Button>
        </ModalFooter>
        <Row>
          <Box
            basis={12}
            className={css`
              padding-left: 40px;
            `}
          >
            <Text font="bodyStrong">Key:</Text>
            <Text
              font="body"
              className={css`
                padding-left: 10px;
              `}
            >
              {diagnosticCollectionSettings.uuid}
            </Text>
          </Box>
        </Row>
      </Box>
      <DiagnosticCollectionStopModal
        onClick={onClick}
        formValue={formValue}
        onCancel={() => {
          setVisible(false)
        }}
        visible={visible}
      />
    </>
  )
}
